import { defineSlotRecipe } from '@chakra-ui/react';
import { nativeSelectAnatomy } from '@chakra-ui/react/anatomy';
import { selectSlotRecipe } from './select.recipe';

export const nativeSelectSlotRecipe = defineSlotRecipe({
  className: 'chakra-native-select',
  slots: nativeSelectAnatomy.keys(),

  base: {
    root: {
      height: 'fit-content',
      display: 'flex',
      width: '100%',
      position: 'relative',
    },
    field: {
      width: '100%',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderRadius: 'l',
      borderColor: 'border.accent',
      textStyle: 'body.s.regular',
      color: 'text.primary',
      bg: 'background.secondary',

      _placeholder: {
        color: 'text.quaternary',
      },
      _hover: {
        borderColor: 'border.accent.hover',
      },
      _focus: {
        borderColor: 'border.accent.active',
        outline: 'none',
        _hover: {
          borderColor: 'border.accent.active',
        },
      },
      _focusVisible: {
        focusRing: 'none',
      },
      _invalid: {
        borderColor: 'border.error',
        _hover: {
          borderColor: 'border.error',
        },
      },
      _disabled: {
        cursor: 'not-allowed',
        opacity: 'disabled',
      },
    },
    indicator: {
      position: 'absolute',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'none',
      top: '50%',
      transform: 'translateY(-50%)',
      height: '100%',
      color: 'fg.muted',
      _disabled: {
        opacity: 'disabled',
      },
      _invalid: {
        color: 'fg.error',
      },
      _icon: {
        width: '1em',
        height: '1em',
      },
    },
  },

  variants: {
    variant: {
      primary: {
        root: {},
        field: {
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'border.accent',
          _focus: {
            borderColor: 'border.accent.active',
            boxShadow: 'none',
          },
          _invalid: {
            borderColor: 'text.error',
            _focus: {
              borderColor: 'text.error',
              boxShadow: 'none',
            },
          },
        },
      },
      outline: {
        field: selectSlotRecipe.variants?.variant.outline.trigger,
      },
      subtle: {
        field: selectSlotRecipe.variants?.variant.subtle.trigger,
      },
      plain: {
        field: {
          bg: 'transparent',
          color: 'fg',
          focusRingWidth: '2px',
        },
      },
      ghost: {
        field: selectSlotRecipe.variants?.variant.ghost.trigger,
      },
    },
    size: {
      md: {
        field: {
          textStyle: 'body.s.regular',
          h: '42px',
          minH: '42px',
          py: 's',
          px: 's',
          '--input-height': '42px',
        },
        indicator: {
          textStyle: 'lg',
          insetEnd: '2',
        },
      },
    },
  },

  defaultVariants: {
    size: 'md',
    variant: 'primary',
  },
});
